import axiosPost from "./axiosPost";

export const rolGet = async (servicioCod, credentials, tipo = '') => {
    const body = {
        service: "RolGet",
        params: {
            servicioHooliCod: servicioCod,
            rolTipo: tipo,
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
